<form
    ng-form="surveyorDetailsForm"
    class="well">
    <h5>Surveyor details</h5>

    <div class="row">
        <div class="col-xs-6">
            <label class="control-label">Preallocated survey firm</label>
            @if (firm) {
                <div
                    class="input-group"
                    [ngClass]="{'has-error': !preallocatedFirm.value && submitted}"
                    ng-class="{'has-error': surveyorDetailsForm.firm.$invalid
                    && (surveyorDetailsForm.firm.$dirty || surveyorDetailsForm.$submitted)}">
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-edit"></i>
                    </span>
                    <input
                        type="text"
                        name="firm"
                        class="form-control"
                        #preallocatedFirm="ngModel"
                        [ngModel]="firm.firmName"
                        (ngModelChange)="onSurveyFirmChange($event)"
                        uib-typeahead="firm.firmNumber as firm.firmName for firm in $ctrl.firms"
                        typeahead-editable="false"
                        typeahead-input-formatter="$ctrl.formatFirm()"
                        typeahead-on-select=""
                        [disabled]="true" />
                </div>
            }

            @if (!isFirmNameValid() && submitted) {
                <div
                    class="help-block"
                    ng-if="surveyorDetailsForm.firm.$invalid && (surveyorDetailsForm.firm.$dirty || surveyorDetailsForm.$submitted)">
                    <span>Error!</span>
                    <span>Preallocated survey firm not found.</span>
                </div>
            }
        </div>
        <div class="col-xs-6">
            <label class="control-label required-input"> Certifying surveyor name</label>
            <div
                class="input-group"
                [ngClass]="{'has-error': !isCertifyingSurveyorValid || (certifyingSurveyor.invalid && submitted)}"
                ng-class="{'has-error': surveyorDetailsForm.certifyingSurveyor.$invalid
                    && (surveyorDetailsForm.certifyingSurveyor.$dirty || surveyorDetailsForm.$submitted)}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                    type="text"
                    name="certifyingSurveyor"
                    id="certifyingSurveyor"
                    class="form-control"
                    placeholder="Search certifying surveyor"
                    title="Select the certifying surveyor name"
                    autocomplete="off"
                    #certifyingSurveyor="ngModel"
                    [(ngModel)]="selectedSurveyorName"
                    (ngModelChange)="onSurveyorNameChange()"
                    ng-model="$ctrl.model.certifyingSurveyorIdNumber"
                    ng-change="$ctrl.certifyingSurveyorChange()"
                    uib-typeahead="surveyor.surveyorIdNumber as surveyor.familyName + ' ' + surveyor.givenNames for surveyor in
                            $ctrl.filterEligibleSurveyorsByFullName($viewValue)"
                    typeahead-editable="false"
                    [nlrTypehead]="surveyorNameSearch"
                    ngModel
                    typeahead-input-formatter="$ctrl.formatCertifyingSurveyor()"
                    required />
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-search"></i>
                </span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-6">
            <label class="control-label">Preallocated surveyor name</label>
            <div
                class="input-group"
                [ngClass]="{'has-error': !isAllocatedSurveyorValid}"
                ng-class="{'has-error': surveyorDetailsForm.surveyor.$invalid
                    && (surveyorDetailsForm.surveyor.$dirty || surveyorDetailsForm.$submitted)}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                    type="text"
                    name="preallocatedSurveyor"
                    id="preallocatedSurveyor"
                    class="form-control"
                    placeholder="Search preallocated surveyor"
                    title="Select the preallocated surveyor name"
                    autocomplete="off"
                    #preallocatedSurveyor="ngModel"
                    [(ngModel)]="selectedAllocatedSurveyorName"
                    (ngModelChange)="onAllocatedSurveyorNameChange()"
                    ng-model="$ctrl.model.surveyorIdNumber"
                    ng-change="$ctrl.surveyorChange()"
                    uib-typeahead="surveyor.surveyorIdNumber as surveyor.familyName + ' ' + surveyor.givenNames for surveyor in
                            $ctrl.filterAllocatedSurveyorsByFullName($viewValue)"
                    typeahead-editable="false"
                    [nlrTypehead]="preAllocatedSurveyorNameSearch"
                    typeahead-input-formatter="$ctrl.formatSurveyor()" />
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-search"></i>
                </span>
            </div>
        </div>
    </div>
</form>
